module.exports = __webpack_public_path__ + "static/media/ppt.ed55bacf.svg";